import Alert from "../Alert"


export const CashInUnavailableAlert = ({ isOpen, onClose }) => {
    return (
        <Alert
            title="Cash in unavailable"
            description="New investments are no longer accepted for this fund. Explore other available funds to continue investing."
            isOpen={isOpen}
            isCancel={false}
            btnTxt="OK"
            handleAction={onClose}
            />
    )

}